import { useState } from 'react';


import { Box, Button, Typography } from '@mui/material';

import {
  marketingSectionSx,
  marketingInnerSx,
  sectionEyebrowSx,
  sectionTitleSx,
  capabilitySectionSx,
  capabilityInnerSx,
  capabilityListSx,
  capabilityItemSx,
  statCardsSx,
  statCardSx,
  statIconSx,
  statValueSx,
  statTextSx,
  practiceSectionSx,
  practiceInnerSx,
  faqSectionSx,
  faqTitleSx,
  faqGridSx,
  faqColumnSx, trialCardSx,
  trialTitleSx,
  trialDescriptionSx,
  productImageSx
} from '../../Common/components/Styles/AuthStyles';
import desktopPreview from '../../../assets/images/Image1.png';
import laptopPreview from '../../../assets/images/Image2.png';
import {
  HourTimeLine,
  ChartPerformance
} from '../../Common/components/Icons/icons';
import {
  Add,
  ArrowForwardOutlined,
  Remove,
  SentimentSatisfiedAltOutlined
} from '@mui/icons-material';

import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

const faqItemsLeft = [
  {
    id: 'card',
    question: 'Do I need a credit card to start?',
    answer:
      'A credit card is required to activate your account after registration.'
  },
  {
    id: 'cost',
    question: 'How much does it cost after the trial?',
    answer:
      'One simple plan billed monthly per provider, with no setup fees and no long-term contract. You\'ll always see pricing before you enter any payment details.'
  },
  {
    id: 'setup',
    question: 'How long does setup take?',
    answer:
      'Your account can be configured quickly, and setup assistance and training are included.'
  }
];

const faqItemsRight = [
  {
    id: 'security',
    question: 'Is it secure and certified?',
    answer:
      'EHRZip is designed to securely manage healthcare information and patient records.'
  },
  {
    id: 'support',
    question: 'What kind of support do I get?',
    answer:
      'Setup assistance, training and ongoing product support are included.'
  }
];

const MarketingSection = () => {
  const [expandedFaq, setExpandedFaq] = useState('cost');

  const renderFaqItem = item => {
    const expanded = expandedFaq === item.id;

    return (
      <Accordion
        key={item.id}
        expanded={expanded}
        onChange={() => setExpandedFaq(expanded ? '' : item.id)}
        disableGutters
        elevation={0}
        square
        sx={{
          backgroundColor: 'transparent',
          borderBottom: '1px solid #E0E0E0',
          boxShadow: 'none',
          m: '0 !important',

          '&::before': {
            display: 'none'
          },

          '&.Mui-expanded': {
            m: '0 !important'
          }
        }}>
        <AccordionSummary
          expandIcon={
            expanded ? (
              <Remove
                sx={{
                  color: '#757575',
                  fontSize: 22
                }}
              />
            ) : (
              <Add
                sx={{
                  color: '#757575',
                  fontSize: 22
                }}
              />
            )
          }
          sx={{
            minHeight: 76,
            px: 0,
            py: 0,

            '&.Mui-expanded': {
              minHeight: 76
            },

            '& .MuiAccordionSummary-content': {
              my: 0
            },

            '& .MuiAccordionSummary-content.Mui-expanded': {
              my: 0
            },

            '& .MuiAccordionSummary-expandIconWrapper': {
              mr: 0
            },

            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'none'
            }
          }}>
          <Typography
            sx={{
              color: '#B3833B',
              fontSize: 18,
              fontWeight: 400,
              lineHeight: 1.4
            }}>
            {item.question}
          </Typography>
        </AccordionSummary>

        <AccordionDetails
          sx={{
            px: 0,
            pt: 0,
            pb: 2.5
          }}>
          <Typography
            sx={{
              color: '#424242',
              fontSize: 15,
              fontWeight: 400,
              lineHeight: 1.5,
              maxWidth: 610
            }}>
            {item.answer}
          </Typography>
        </AccordionDetails>
      </Accordion>
    );
  };

  return (
    <>
      {/* Everything You Need */}
      <Box sx={marketingSectionSx}>
        <Box sx={marketingInnerSx}>
          <Box
            component="img"
            src={laptopPreview}
            alt="EHRZip application"
            sx={productImageSx}
          />

          <Box>
            <Typography sx={sectionEyebrowSx}>
              EVERYTHING YOU NEED FOR BETTER PATIENT CARE
            </Typography>

            <Typography sx={sectionTitleSx}>
              Securely access patient records, manage appointments, document
              clinical encounters, and streamline care delivery.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* AI Capabilities */}
      <Box sx={capabilitySectionSx}>
        <Box sx={capabilityInnerSx}>
          <Box>
            <Typography sx={sectionEyebrowSx}>
              AI CAPABILITIES & PLATFORM INTEGRATIONS
            </Typography>

            <Box sx={capabilityListSx}>
              {[
                'AI ICD 10 & Diagnosis',
                'AI Assist SOAP Note Composition',
                'App Store & Google Play — Scan to Download'
              ].map(item => (
                <Box key={item} sx={capabilityItemSx}>
                  <ArrowForwardOutlined />

                  <Typography>{item}</Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Statistics */}
          <Box sx={statCardsSx}>
            <Box
              sx={{
                ...statCardSx,
                backgroundColor: '#E8F4FB'
              }}>
              <Box sx={{ ...statIconSx, color: '#3C68A3' }}>
                <HourTimeLine />
              </Box>

              <Typography sx={statValueSx}>50%</Typography>

              <Typography sx={statTextSx}>
                Decrease In
                <br />
                Charting Time
              </Typography>
            </Box>

            <Box
              sx={{
                ...statCardSx,
                backgroundColor: '#FBF3E3'
              }}>
              <Box sx={{ ...statIconSx, color: '#98763F' }}>
                <ChartPerformance />
              </Box>

              <Typography sx={{ ...statValueSx, color: '#98763F' }}>
                100%
              </Typography>

              <Typography sx={{ ...statTextSx, color: '#98763F' }}>
                Increase In Doctor&apos;s
                <br />
                Efficiency
              </Typography>
            </Box>

            <Box
              sx={{
                ...statCardSx,
                backgroundColor: '#E9F6EA'
              }}>
              <Box sx={{ ...statIconSx, color: '#2E7D32' }}>
                <SentimentSatisfiedAltOutlined />
              </Box>

              <Typography sx={{ ...statValueSx, color: '#2E7D32' }}>
                50%
              </Typography>

              <Typography sx={{ ...statTextSx, color: '#2E7D32' }}>
                Increase In Patients
                <br />
                Satisfaction
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Practice Solution */}
      <Box sx={practiceSectionSx}>
        <Box sx={practiceInnerSx}>
          <Box
            component="img"
            src={desktopPreview}
            alt="EHRZip practice management"
            sx={productImageSx}
          />

          <Box>
            <Typography sx={sectionEyebrowSx}>
              ALL-IN-ONE PRACTICE & PATIENT CARE SOLUTION
            </Typography>

            <Box sx={capabilityListSx}>
              {[
                'All-in-One Provider–Office–Patient Communication',
                'Schedule Anytime, Anywhere',
                'Real-Time Prescription & Doctor’s Order Execution by Office Staff',
                '$129/month per user — Patients use it for FREE'
              ].map(item => (
                <Box key={item} sx={capabilityItemSx}>
                  <ArrowForwardOutlined />

                  <Typography>{item}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* FAQ */}
      <Box sx={faqSectionSx}>
        <Typography sx={sectionEyebrowSx}>QUESTIONS, ANSWERED</Typography>

        <Typography sx={faqTitleSx}>Before you start your trial</Typography>

        <Box sx={faqGridSx}>
          <Box sx={faqColumnSx}>{faqItemsLeft.map(renderFaqItem)}</Box>

          <Box sx={faqColumnSx}>{faqItemsRight.map(renderFaqItem)}</Box>
        </Box>

        {/* Start Trial */}
        <Box sx={trialCardSx}>
          <Typography sx={trialTitleSx}>
            Start charting faster, not later.
          </Typography>

          <Typography sx={trialDescriptionSx}>
            Begin your free 14-day trial today. A credit card is required to
            activate your account. Free setup and training are included.
          </Typography>

          <Button
            endIcon={<ArrowForwardOutlined />}
            onClick={() =>
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              })
            }
            variant="contained">
            Start Free 14-Day Trial
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default MarketingSection;
